
import { LostRevenue, WorksheetId } from './domain';
import { fetchRequest } from './';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'lostrevenue';

export type LostRevenueResult = WorksheetResult<LostRevenue>;
export type LostRevenueListResult = WorksheetResult<LostRevenue[]>;

export const saveLostRevenueRequest = fetchRequest<
  LostRevenue,
  LostRevenueResult
>({
  method: 'post',
  body: (args: LostRevenue) =>
    worksheetMessage(args, 'savelostrevenue', service),
});

export const updateLostRevenueRequest = fetchRequest<
  LostRevenue,
  LostRevenueResult
>({
  method: 'post',
  body: (args: LostRevenue) =>
    worksheetMessage(args, 'updatelostrevenue', service),
});


export const getLostRevenuesRequest = fetchRequest<
  WorksheetId,
  LostRevenueListResult
>({
  method: 'post',
  body: (args: WorksheetId) =>
    worksheetMessage(args, 'getlostrevenue', service),
  notFoundResult: () => ({ result: [] }),
});

interface LostRevenueIds extends WorksheetId {
  lostRevenueId: string;
}

export type LostRevenueIdsResult = WorksheetResult<LostRevenueIds>;
export const deleteLostRevenuesRequest = fetchRequest<
  LostRevenueIds,
  LostRevenueIdsResult
>({
  method: 'post',
  body: (args: LostRevenueIds) =>
    worksheetMessage(args, 'deletelostrevenue', service),
});

